<script setup lang="ts">
import type { ITableColumnsOptions } from '@modules/tables/types';
import VButton from '@components/buttons/VButton/VButton.vue';
import VCard from '@components/card/VCard/VCard.vue';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES,
} from '@modules/affiliate-program-promo-codes/constants';
import { useAffiliateProgramPromoCodesListQuery } from '@modules/affiliate-program-promo-codes/queries';
import { AFFILIATE_PROGRAM_PROMO_CODES_CREATE_ROUTE_NAME } from '@modules/affiliate-program-promo-codes/submodules/create/constants';
import VTable from '@modules/tables/components/VTable/VTable.vue';
import { useTableData } from '@modules/tables/composables';

const {
  tableState,
  isLoading,
  isFetching,
  data,
  updateTableState,
  refreshTableData,
} = useTableData(useAffiliateProgramPromoCodesListQuery);

const columnOptions: ITableColumnsOptions = {
  code: {
    defaultMobilePreview: true,
  },
};
</script>

<template>
  <VCard v-data-qa-auto-id="'AffiliateProgramPromoCodesListPage'" type="table">
    <VTable
      :data="data"
      :state="tableState"
      :loading="isLoading"
      :is-fetching="isFetching"
      :title-t-path="$getTPath(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, 'HEADER')"
      :columns-options="columnOptions"
      @state-update="updateTableState"
      @refresh="refreshTableData"
    >
      <template
        v-if="$hasPermission(AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.CREATE)"
        #footerButtons
      >
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES, 'CREATE_BUTTON')"
          :to="{ name: AFFILIATE_PROGRAM_PROMO_CODES_CREATE_ROUTE_NAME }"
        />
      </template>
    </VTable>
  </VCard>
</template>
